import React, { useEffect, useState, useRef } from "react";
import axios from 'axios';
import MyComponentbeta from "./Rickybeta";
import { useAuth0 } from '@auth0/auth0-react';
import HamsterAnimation from "../../animation/loader";
import LogsList from "./List";
import Parea from "./Parea";
import PopupComponent from "./pupup/PopupComponent";
function Transcriptionbeta() {
    const [logs, setLogs] = useState([]);
    const [sessionId, setSessionId] = useState(null);
    const [token, setToken] = useState(null); // State to hold the token
    const [coneccion, setConeccion] = useState(false); // State to hold if websocket connection is established
    const socketRef = useRef(null);
    const { getAccessTokenSilently } = useAuth0();
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const [contexto, setContexto] = useState('');
    useEffect(() => {
        const storedLogs = localStorage.getItem('logs');
        if (storedLogs) {
            setLogs(JSON.parse(storedLogs));
        }
    }, []);

    // Effect to get the access token on component mount
    useEffect(() => {
        getAccessTokenSilently()
            .then(setToken)
            .catch(console.error);
    }, []);

    // Effect to start the transcription once the token is retrieved
    useEffect(() => {
        if (token) { // Check if the token is not null
            axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/start_transcription`, {}, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((response) => {
                setSessionId(response.data.user_id);
                console.log("User id in transcription:", response.data.user_id);
            })
            .catch((error) => {
                console.error("Error starting transcription", error);
                console.log("Error starting transcription", error);
                if (error.response && error.response.status === 403) {
                    setPopupMessage("La transcripción en tiempo real está disponible exclusivamente para nuestros usuarios Pro. Por favor, actualice su cuenta para acceder a esta característica.");
                setShowPopup(true);
                } 
            });
        }
    }, [token]); // This useEffect now depends on the token

    // Effect to set up the WebSocket connection once the session ID is available
    useEffect(() => {
        const setupWebSocket = () => {
            const newSocket = new WebSocket(`${process.env.REACT_APP_API_BASE_URL_WS}/ws/${sessionId}?token=${token}`);
            newSocket.onopen = () => {console.log('WebSocket Connection Established');
            setConeccion(true);};
            newSocket.onclose = (event) => {console.log('WebSocket Connection Closed', event);
            setConeccion(false);};
            newSocket.onerror = (error) => {console.error('WebSocket Error', error);
            setConeccion(false);};
            newSocket.onmessage = (event) => {
                console.log("Received message", event.data);
                const data = event.data;
                localStorage.setItem('lastMessage', event.data);
                setLogs((prevLogs) => {
                    const updatedLogs = [...prevLogs, data];
                    localStorage.setItem('logs', JSON.stringify(updatedLogs)); // Save updated logs to local storage
                    return updatedLogs;
                });
              
            };
            socketRef.current = newSocket;
        };

        if (sessionId) { // Ensure that both sessionId and token are available
            setupWebSocket();
        }

        // Cleanup function for WebSocket
        return () => {
          if (socketRef.current) {
            socketRef.current.close();
          }
        };
    }, [sessionId]); // This useEffect now depends on both sessionId and token
    //delete local storage 
    const deleteLogs = () => {
        localStorage.removeItem('logs');
        localStorage.removeItem('procedureResponse');
        localStorage.removeItem('sharingResponse');
        localStorage.removeItem('lastMessage');
        setLogs([]);
    };
    const deleteLog = (index) => {
        // Confirm deletion with a popup first
        /*setShowPopup(true);
        setPopupMessage("Are you sure you want to delete this log?");
        // On confirmation:
        const updatedLogs = logs.filter((_, i) => i !== index);
        setLogs(updatedLogs);
        localStorage.setItem('logs', JSON.stringify(updatedLogs));*/
        //show an alert of the actino, if theres a confirmation then yes delete it, if not then do not delete it
        if (window.confirm("Are you sure you want to delete this log?")) {
            const updatedLogs = logs.filter((_, i) => i !== index);
            setLogs(updatedLogs);
            localStorage.setItem('logs', JSON.stringify(updatedLogs));
        }
      };

    return (
        <div className="content-section">
            {showPopup && <PopupComponent message={popupMessage} onClose={() => setShowPopup(false)} />}
            <p><button className="content-button" onClick={deleteLogs}>Iniciar nueva transcripcion</button></p>
            <h2>Transcription:</h2>
            <p>Session ID: {sessionId}</p>
            <p>Connection: {coneccion ? <span style={{ color: "rgba(0, 255, 0)" }}>Connected</span> : <span style={{ color: "red" }}>Disconnected</span>}</p>
            <MyComponentbeta userid={sessionId} socketRef={socketRef} contexto={contexto} setContexto={setContexto} />
            <LogsList logs={logs} onDelete={deleteLog} />
            <Parea logs={logs} context={contexto} />
        </div>
    );

}
/*
<div className="content-section">
                <textarea value={message} onChange={(e) => setMessage(e.target.value)} />
                <button onClick={sendMessage}>Send Message</button>
            </div>
            
            
            const sendMessage = async () => {
        if (token) { // Check if the token is available
            try {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/send_message`, {
                    user_id: sessionId,
                    text: message
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setMessage('');
            } catch (error) {
                console.error("Error sending message", error);
            }
        }
    };*/

export default Transcriptionbeta;
